// eslint-disable-next-line no-unused-vars
const prod = 'https://admin.moc.interactiva.net.co/';
const local = 'http://127.0.0.1:8000/';
const API_BASE_URL = prod;
export const IMAGE_BASE_URL = 'https://admin.moc.interactiva.net.co';

export const headerHttpPeticions = {
    'Access-Control-Allow-Origin': '*',  // Permite solicitudes desde cualquier origen
    'Access-Control-Allow-Methods': 'GET, POST',  // Métodos permitidos
    'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token',  // Encabezados permitidos
    'Content-Type': 'application/json',  // Tipo de contenido de la respuesta esperada
}

export default API_BASE_URL;